import { APThemeTypes } from '@astropay/web-core-library';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

export interface IAPThemeState {
  actualTheme: APThemeTypes;
}

const initialState = { actualTheme: APThemeTypes.ASTROPAY_DARK_V2 };

/**
 * @deprecated Do not use - theme option removed
 */
export const APThemeSlice = createSlice({
  name: 'ap-theme',
  initialState,
  reducers: {
    resetStore: (state) => {
      state = initialState;
      return state;
    },
    setAPTheme: (state, action: PayloadAction<APThemeTypes>) => {
      state.actualTheme = action.payload;
    },
  },
});

// Selectors
const getAPThemeState = (state: RootState): IAPThemeState => state.apTheme;

export const getAPThemeSetting = createSelector(getAPThemeState, (theme) => theme.actualTheme);

const { actions, reducer } = APThemeSlice;

export const { setAPTheme, resetStore: APThemeResetStore } = actions;

export default reducer;
